import { useContext, useEffect, useState } from "react";
import { TableContext, SettingsContext } from "../App";
import Api from "./api/api";
import "../css/Limits.css";
import UserIcon from "../icons/UserIcon";
import ClockIcon from "../icons/ClockIcon";

function Limits() {
	const { timerActive, limits } = useContext(SettingsContext);
	const { table } = useContext(TableContext);
	const [expanded, setExpanded] = useState(false);

	return (
		<>
			{(limits.length > 0 || timerActive) && (
				<div className={"limits" + (expanded ? " open" : "")}>
					<div className="limits-container">
						<button onClick={() => setExpanded(!expanded)}>
							{expanded ? <>&#62;</> : <>&#60;</>}
						</button>
						<div className="content">
							<div className="container-coves">
								<div className="covers">
									<UserIcon></UserIcon>
									<b>{table.covers}</b>
								</div>
								{timerActive && (
									<div className="covers">
										<ClockIcon></ClockIcon>
										<b>{timerActive}</b>
									</div>
								)}
							</div>
							{limits.length > 0 && (
								<div className="list-group">
									{limits.map((group) => (
										<div key={group.id}>
											<b>
												{group.used}/{group.order_limit}
											</b>{" "}
											{group.name}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default Limits;
